export const VISITING_MEMBER_PATH = '/home/dailyreservations';
